<template>
  <section>
    <div class="filter-top-select">
      <span
        :class="{'is_active':is_select==0}"
        @click="handleChange(0)">HD Activity</span>
      <span
        v-if="is_tier_base"
        :class="{'is_active':is_select==3}"
        @click="handleChange(3)">Statement</span>
      <span
        :class="{'is_active':is_select==1}"
        @click="handleChange(1)">Membership</span>
      <span
        v-if="!isFina"
        :class="{'is_active':is_select==2}"
        @click="handleChange(2)">{{isFina?'Reward Settings':'Settings'}}</span>
      <span
        v-if="isFina"
        :class="{'is_active':is_select==5}"
        @click="handleChange(5)">Product Setting</span>
      <span
        v-if="isFina"
        :class="{'is_active':is_select==4}"
        @click="handleChange(4)">Team Summary</span>
    </div>
    <referral
      v-if="is_select==0"
      :form="form"
      :customer-id="customerId"
      :is-fina="isFina"
      @update="handleUpdate"
      @activeName="handleActiveName"></referral>
    <member-ship
      v-if="is_select==1"
      :form="form"
      :customer-id="customerId"
      @update="handleUpdate"></member-ship>
    <template  v-if="is_select==2&&!isFina">
      <settings
        v-if="!isFina"
        :time="last_updated"
        @update="handleUpdate"></settings>
      <reward-setting
        :form="form"
        is-account
        :customer-id="customerId"
        @update="handleUpdate"></reward-setting>
    </template>
    <statement-list
      v-if="is_select==3"
      :customer-id="customerId"
    ></statement-list>
    <incentive-bonus-detail
      v-if="is_select==4"
      is-account
      :customer-id="customerId"></incentive-bonus-detail>
    <product-setting  v-if="is_select==5"></product-setting>
  </section>
</template>

<script>
import Referral from './referral'
import memberShip from './memberShip'
import settings from './settings'
import rewardSetting from './reward-setting'
import statementList from './statement-list'
import incentiveBonusDetail from '@/views/records/referrerReward/component/incentiveBonusDetail'
import ProductSetting from '@/views/accounts/components/product-setting'
export default {
  name: 'hdMember',
  components: {
    ProductSetting,
    Referral,
    memberShip,
    settings,
    statementList,
    incentiveBonusDetail,
    rewardSetting
  },
  props: {
    // customerId: [String, Number],
    // form: {
    //   type: Object,
    //   default: () => ({})
    // }
  },
  inject:['detailData','customer_id'],
  data() {
    return {
      is_select: 0,
    }
  },
  computed:{
    isFina(){
      let {customer_profile} = this.form||{}
      let {account_type} =customer_profile||{}
      return account_type == 2

    },
    form(){
      return this.detailData()
    },
    customerId(){
      return this.customer_id()
    },
    is_tier_base(){
      let {customer_profile} = this.form||{}
      let {is_tier_base=false} = customer_profile||{}
      return is_tier_base||false
    },
    last_updated(){
      let { customer_profile} = this.form||{}
      let {referral_reward_last_updated } = customer_profile||{}
      return referral_reward_last_updated||''
    }
  },
  methods:{
    handleActiveName(name){
      this.$router.push({
        name,
        query:{
          customer_id: this.customerId
        }
      })
    },
    handleChange(data){
      this.is_select = data
    },

    handleUpdate(){
      this.$emit('update')
    }
  }
}
</script>

<style scoped lang="scss">
.filter-top-select{
  margin-bottom: 20px;
  border-bottom: 1px solid #E1E4E8;
//padding-bottom: 16px;
  display: flex;
  span{
    padding: 12px 16px 10px 16px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #586069;
    display: block;
    cursor: pointer;
    &.is_active{
       color: #24292E;
       border: 1px solid #E1E4E8;
       border-bottom: 0;
       background: #fff;
       margin-bottom: -1.2px;
       border-top-left-radius: 5px;
       border-top-right-radius: 5px;
     }
    &:first-child{
       margin-left: 10px;
     }
  }
}
</style>
